export const strToBlob = txt => {
  return new Blob([txt])
}
